import { EpimsBaseEntityDto } from './epim-base.dto';
export class EngagementCategoryDto extends EpimsBaseEntityDto {

    EngagementCategoryId: string;

    EngagementCategoryName: string;

   

}